import { Link } from 'react-router-dom'
import { ArrowLeft } from 'lucide-react'

const sections = [
  {
    number: 1,
    title: 'License Grant',
    paragraphs: [
      'ARYA grants you a personal, non-commercial, non-transferable, revocable license to access and use the platform and its services in accordance with these terms.',
      'This license is valid solely within the scope defined by the ARYA Terms of Service and this End User License Agreement.',
    ],
  },
  {
    number: 2,
    title: 'Restrictions',
    paragraphs: [
      'You may not decompile, reverse-engineer, disassemble, copy, modify, distribute, or create derivative works based on the platform or any of its components.',
      'Recording, downloading, redistributing, or publicly displaying any course videos, materials, or content from the platform is strictly prohibited.',
      'Sharing a single account among multiple users, using automated tools or bots to scrape content, or circumventing access controls constitutes a violation of this agreement.',
    ],
  },
  {
    number: 3,
    title: 'Intellectual Property',
    paragraphs: [
      'All content on the ARYA platform — including but not limited to courses, videos, images, text, graphics, and design elements — is the intellectual property of ARYA and its respective content creators.',
      'Your use of the platform does not grant you any ownership rights to the content. You are granted a limited right to view and learn from the content for personal use only.',
    ],
  },
  {
    number: 4,
    title: 'Account Termination',
    paragraphs: [
      'You may terminate your account at any time by contacting support or through your account settings.',
      'ARYA reserves the right to suspend or terminate any account that violates this agreement, without prior notice. Repeated or severe violations may result in a permanent ban.',
      'Upon termination, no refunds will be issued for any active subscriptions or unused portions thereof.',
    ],
  },
  {
    number: 5,
    title: 'Limitation of Liability',
    paragraphs: [
      'The ARYA platform is provided "as is" without warranties of any kind, whether express or implied, including but not limited to warranties of merchantability, fitness for a particular purpose, or non-infringement.',
      'ARYA shall not be held liable for service interruptions, server downtime, data loss, or disruptions caused by third-party services.',
      'In no event shall ARYA be liable for any indirect, incidental, special, consequential, or punitive damages arising from your use of the platform.',
    ],
  },
  {
    number: 6,
    title: 'Modifications to This Agreement',
    paragraphs: [
      'ARYA reserves the right to modify this agreement at any time. Updated terms will be posted on the platform with the revised effective date.',
      'Your continued use of the platform following any modifications constitutes your acceptance of the updated terms.',
    ],
  },
  {
    number: 7,
    title: 'Governing Law',
    paragraphs: [
      'This agreement shall be governed by and construed in accordance with the laws of Mongolia.',
      'Any disputes arising from this agreement shall first be resolved through good-faith negotiation. If a resolution cannot be reached, the matter shall be submitted to the competent courts of Mongolia.',
    ],
  },
]

export default function EULA() {
  return (
    <div className="min-h-screen bg-gray-50">
      {/* Header */}
      <div className="bg-white border-b border-gray-200 py-4">
        <div className="max-w-[1024px] mx-auto px-4">
          <Link
            to="/"
            className="inline-flex items-center gap-2.5 text-sm font-medium text-gray-800 bg-white border border-gray-200 rounded-full px-4 py-2.5 shadow-md hover:bg-gray-50 transition"
          >
            <ArrowLeft className="size-5" />
            Back
          </Link>
        </div>
      </div>

      {/* Title */}
      <div className="text-center pt-8 pb-6">
        <h1 className="text-3xl md:text-5xl font-bold text-gray-800">
          END USER LICENSE AGREEMENT
        </h1>
        <p className="text-base text-gray-500 mt-3 max-w-[540px] mx-auto">
          Please read this agreement carefully before using the ARYA platform.
        </p>
      </div>

      {/* Content */}
      <div className="max-w-[1024px] mx-auto px-4 pb-20">
        <div className="flex flex-col gap-8">
          {sections.map((section) => (
            <div key={section.number} className="flex flex-col gap-6">
              <div className="flex flex-col gap-6 items-end">
                <h2 className="w-full text-2xl font-medium text-gray-800">
                  <ol start={section.number} className="list-decimal pl-9">
                    <li>{section.title}</li>
                  </ol>
                </h2>
                <hr className="border-gray-200 w-full" />
                <div className="flex flex-col gap-4 w-full">
                  {section.paragraphs.map((paragraph, index) => (
                    <p key={index} className="text-lg text-gray-600 leading-relaxed">
                      {paragraph}
                    </p>
                  ))}
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  )
}
